import { z } from 'zod';

const envSchema = z.object({
  VITE_API_BASE_URL: z.string().url(),
  VITE_APP_TITLE: z.string().min(1),
  VITE_ENABLE_MOCK_API: z.string().transform((v) => v === 'true'),
  VITE_MSAL_CLIENT_ID: z.string().uuid(),
  VITE_MSAL_TENANT_ID: z.string().uuid(),
  VITE_API_SCOPE: z.string().min(1).optional(),
  VITE_TRAVELS_API: z.string().url(),
  VITE_PROFILES_API: z.string().min(1),
  VITE_IS_SECURITY_ENABLED: z.enum(['Y', 'N']).default('N'),
});

type RuntimeConfig = Partial<Record<keyof z.input<typeof envSchema>, string>>;

function isUnresolvedToken(value: string): boolean {
  return /^__[^\s]+__$/.test(value);
}

function getRuntimeConfig(): RuntimeConfig {
  if (typeof window === 'undefined' || !window.__ARP_CONFIG__) {
    return {};
  }

  const filteredEntries = Object.entries(window.__ARP_CONFIG__).filter(([, value]) => {
    if (typeof value !== 'string') {
      return false;
    }

    return !isUnresolvedToken(value);
  });

  return Object.fromEntries(filteredEntries) as RuntimeConfig;
}

const mergedEnv = import.meta.env.MODE === 'test'
  ? {
      ...getRuntimeConfig(),
      ...import.meta.env,
    }
  : {
      ...import.meta.env,
      ...getRuntimeConfig(),
    };

export const env = envSchema.parse(mergedEnv);
